import webLink from "../../assets/images/links/globe2.svg";
import dribbbleLink from "../../assets/images/links/dribbble.svg";
import gitLink from "../../assets/images/links/github.svg";
import ytLink from "../../assets/images/links/youtube.svg";

import fakesoftware from "../../assets/images/projects/fakesoftware.png"
import aiportfolio from "../../assets/images/projects/aiportfolio.png"
import textsnatch from "../../assets/images/projects/textsnatch.png"
import twolevel from "../../assets/images/projects/TwoLevel.png"
import cloudstorage from "../../assets/images/projects/Cloud-Storage.png";

import sitevaultweb from "../../assets/images/projects/sitevaultweb.png"
import vibexvisuals from "../../assets/images/projects/vibexvisuals.png"
import thecraftmen from "../../assets/images/projects/thecraftmen.png"

import sitevault from "../../assets/images/projects/SiteVault.png"


export const web = [
  {
    name: "Cloud-Storage-Optimisation",
    date: "2024-01-15",
    cover: cloudstorage,
    links: [
      { icon: gitLink, link: "https://github.com/Rushya5/Cloud-Storage-optimisation" },
      { icon: webLink, link: "https://cloud-storage-sable.vercel.app/" },
    ],
  },
  {
    name: "Two-Level-Security-System",
    date: "2024-01-15",
    cover: twolevel,
    links: [
      { icon: gitLink, link: "https://github.com/Rushya5/Two-Level-Security-System" },
      { icon: webLink, link: "#" },
    ],
  },
  {
    name: "TextSnatch - Extract text from images",
    date: "2024-02-20",
    cover: textsnatch,
    links: [
      { icon: gitLink, link: "https://github.com/Rushya5/Text-Snatch" },
      { icon: webLink, link: "https://text-snatch.vercel.app/" },
    ],
  },
  {
    name: "AI - Portfolio",
    date: "2024-03-10",
    cover: aiportfolio,
    links: [
      { icon: gitLink, link: "https://github.com/Rushya5/Rushya-AI_Portfolio" },
      { icon: webLink, link: "https://rushyaaiportfolio.vercel.app/" },
    ],
  },
  {
    name: "Fake Software Detection-Machine Learning",
    date: "2024-03-10",
    cover: fakesoftware,
    links: [
      { icon: gitLink, link: "https://github.com/Rushya5/Machine-Learning/blob/main/Fake_Software_Detection.ipynb" },
    ],
  },
];

export const design = [
  {
    name: "The Craftmen Landscape Website",
    date: "2023-11-15",
    cover: thecraftmen,
    links: [
      { icon: gitLink, link: "https://github.com/Rushya5/TheCraftmen" },
      { icon: webLink, link: "https://www.thelandscapecraftsmen.com/" },
    ],
  },
  {
    name: "VibeXVisuals Website",
    date: "2023-10-05",
    cover: vibexvisuals,
    links: [
      { icon: gitLink, link: "https://github.com/Rushya5/vibexvisuals" },
      { icon: webLink, link: "https://www.vibexvisuals.in/" },
    ],
  },
  {
    name: "SiteVault - website",
    date: "2023-09-20",
    cover: sitevaultweb,
    links: [
      { icon: gitLink, link: "https://github.com/Rushya5/SiteVault-Website" },
      { icon: webLink, link: "https://sitevault-web.vercel.app/" },
    ],
  },
];

export const exten = [
  {
    name: "SiteVault - Webpage Saver Extension",
    date: "2024-01-15",
    cover: sitevault,
    links: [
      { icon: gitLink, link: "https://github.com/Rushya5/SiteVault---Extension" },
      { icon: webLink, link: "https://sitevault-web.vercel.app/" },
      { icon: dribbbleLink, link: "https://microsoftedge.microsoft.com/addons/detail/sitevault-website-passw/nadcbpoikmhandalibjdgkpcadpploek" },
    ],
  },
];
export const game = [];
